export default "__VITE_ASSET__cjaNBK02__"